<template>
	<div class="content-campaign-flags">
		<!-- TAGS -->
		<div class="campaign-flag">
			<div class="title">Campaign Tags:</div>
			<div class="control-group">
				<div class="inner">
					<label class="control-label">Add tags to label this campaign with for custom functionality...</label>
					<div class="controls">
						<div class="field">
							<p-chips v-model="campaignStore.campaign.tags" add-on-blur />
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- ADD TYP WEIGHT -->
		<div class="campaign-flag">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch input-id="add_typ_weight" v-model="campaignStore.campaign.flags.add_typ_weight.enabled" />
				</div>
				<label for="add_typ_weight">
					<div class="title">Add TYP Weight</div>
					<p>
						Add weight to the campaign's sorting bid if the account has purchased the thank you page ad associated with
						the lead.
					</p>
				</label>
			</div>
		</div>

		<!-- ALGO BIDDING -->
		<div class="campaign-flag" :class="{ disabled: !campaignStore.allow_algo_bidding }">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch
						:disabled="!campaignStore.allow_algo_bidding"
						input-id="algo_bidding"
						v-model="campaignStore.campaign.flags.algo_bidding.enabled"
					/>
				</div>
				<label for="algo_bidding">
					<div class="title">Enable Algo Bidding</div>
					<p>
						In combination with a properly set Ping Post script, this campaign will use algo bidding. Devs require to
						set up ping script.
					</p>
				</label>
			</div>

      <div v-if="campaignStore.campaign.flags.algo_bidding.enabled" class="settings-row">
        <div class="control-group">
          <div class="inner">
            <div class="controls row justify-content-end">
              <div class="field s">
                <p-button label="Load Defaults" @click="setAlgoBiddingDefaults" />
              </div>
            </div>
          </div>
        </div>
      </div>

			<div v-if="campaignStore.campaign.flags.algo_bidding.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Campaign Target CPA:</label>
						<div class="controls">
							<div class="field s">
								<input-currency v-model="campaignStore.campaign.flags.algo_bidding.target_cpa" />
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="campaignStore.campaign.flags.algo_bidding.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Current CPA:</label>
						<div class="controls">
							<div class="field s">
								<input-currency v-model="campaignStore.campaign.flags.algo_bidding.current_cpa" disabled />
							</div>
						</div>
					</div>
					<p>This gets updated when the CR and CPA is calculated for the Vectors. Happens daily.</p>
				</div>
			</div>

			<div v-if="campaignStore.campaign.flags.algo_bidding.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Volume Demand:</label>
						<div class="controls">
							<div class="field s">
								<p-input-percentage v-model="campaignStore.campaign.flags.algo_bidding.volume_demand" />
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="campaignStore.campaign.flags.algo_bidding.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Max CPA Tolerance:</label>
						<div class="controls">
							<div class="field s">
								<p-input-percentage v-model="campaignStore.campaign.flags.algo_bidding.max_cpa_tolerance" />
							</div>
						</div>
						<p>This will affect the bidding mode.</p>
					</div>
				</div>
			</div>

			<div v-if="campaignStore.campaign.flags.algo_bidding.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">CR Bid Deflate Adjustment:</label>
						<div class="controls">
							<div class="field s">
								<p-input-percentage v-model="campaignStore.campaign.flags.algo_bidding.deflated_cr_bid_modifier" />
							</div>
						</div>
						<p>
							This percentage will affect how much the CR bid is deflated if the Bidding Strategy is resolved to
							"Deflate Bid"
						</p>
					</div>
				</div>
			</div>

			<div v-if="campaignStore.campaign.flags.algo_bidding.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">CR Bid Inflate Adjustment:</label>
						<div class="controls">
							<div class="field s">
								<p-input-percentage v-model="campaignStore.campaign.flags.algo_bidding.inflated_cr_bid_modifier" />
							</div>
						</div>
						<p>
							This percentage will affect how much the CR bid is inflated if the Bidding Strategy is resolved to
							"Inflate Bid"
						</p>
					</div>
				</div>
			</div>

			<div v-if="campaignStore.campaign.flags.algo_bidding.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">CPA Standard Deviation Range:</label>
						<div class="controls">
							<div class="field s">
								<p-input-percentage v-model="campaignStore.campaign.flags.algo_bidding.cpa_standard_deviation_range" />
							</div>
						</div>
						<p>
							This is the range which will be used in the scaled CPA calculation. This will be multiplied by the
							standard deviation of the actual CPAs and used in other formulas
						</p>
					</div>
				</div>
			</div>

			<div v-if="campaignStore.campaign.flags.algo_bidding.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Source Target ROI Threshold:</label>
						<div class="controls">
							<div class="field s">
								<p-input-percentage v-model="campaignStore.campaign.flags.algo_bidding.m_target_roi_threshold" />
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="campaignStore.campaign.flags.algo_bidding.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Max Bid Change:</label>
						<div class="controls">
							<div class="field s">
								<p-input-percentage v-model="campaignStore.campaign.flags.algo_bidding.max_bid_change" />
							</div>
						</div>
						<p>This is the maximum a CR Bid can be changed by as a result of the model's weights being applied</p>
					</div>
				</div>
			</div>

			<div v-if="campaignStore.campaign.flags.algo_bidding.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Max Bid:</label>
						<div class="controls">
							<div class="field s">
								<p-input-currency v-model="campaignStore.campaign.flags.algo_bidding.max_bid" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="campaignStore.campaign.flags.algo_bidding.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Split Test Weights</label>
						<div class="controls">
							<div class="field">
								<code-editor v-model.parse.lazy="campaignStore.campaign.flags.algo_bidding.split_testing_weights" />
							</div>
						</div>
					</div>
					<p>
						Currently the only keys that should be used are <code>original</code> or <code>model_b</code>. The numbers
						assigned to any of the keys are 1-100, you must ensure that the sum of the values are 100. i.e. original:
						40, model_b: 60 OR original: 100
					</p>
				</div>
			</div>

			<div v-if="campaignStore.campaign.flags.algo_bidding.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Mode:</label>
						<div class="controls">
							<div class="field s">
								<p-dropdown
									v-model="campaignStore.campaign.flags.algo_bidding.mode"
									:options="algo_mode_options"
									option-label="label"
									option-value="value"
								/>
							</div>
						</div>
					</div>
					<p>
						In test mode, the other model bids will be calculated but not used in the auction. Log will still be
						created. Live Mode will properly split test based on the split test weights.
					</p>
				</div>
			</div>
			<div v-if="campaignStore.campaign.flags.algo_bidding.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Final Bid Modifier</label>
						<div class="controls">
							<div class="field s">
								<p-input-percentage v-model="campaignStore.campaign.flags.algo_bidding.final_bid_modifier" />
							</div>
						</div>
					</div>
					<p>
						This value will be multiplied by the final bid created by the model. This percentage increase or decrease
						will NOT affect the original bid.
					</p>
				</div>
			</div>

      <div v-if="campaignStore.campaign.flags.algo_bidding.enabled" class="settings-row">
        <div class="control-group">
          <div class="inner">
            <div class="controls row justify-content-end">
              <div class="field s">
                <p-button label="Compile Vectors" @click="() => { show_algo_vector_modal = !show_algo_vector_modal;}" />
              </div>
            </div>
          </div>
        </div>
      </div>
		</div>



    <p-dialog v-model:visible="show_algo_vector_modal" modal style="max-width: 600px">
      <template #header>
        <strong>Compile Algo Bidding Vectors</strong>
      </template>
      <p>
        In order to create bidding vectors with accurate CPAs, select the latest date of purchases that the submitted
        conversions from the Buyer cover. Don't select the date the conversions were uploaded, but the last date the
        conversions are supposed to be for.
      </p>
      <p>In order to compile the vectors, you must save the campaign with the defaults and the target CPA. Save those changes
        first and then you can compile the vectors.
      </p>
      <div class="control-group">
        <div class="inner">
          <label class="control-label">Conversion Date:</label>
          <div class="controls">
            <div class="field">
              <date-picker
                  v-model="conversion_date"
              />
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <p-button label="Compile Vectors" @click="compileAlgoVectors"/>
      </template>
    </p-dialog>

		<!-- ALLOW DUPLICATE PURCHASES -->
		<div class="campaign-flag">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch
						input-id="allow_duplicate_purchases"
						v-model="campaignStore.campaign.flags.allow_duplicate_purchases.enabled"
					/>
				</div>
				<label for="allow_duplicate_purchases">
					<div class="title">Allow Duplicate Purchases</div>
					<p>Bypass the duplicate purchase check when qualifying this campaign for leads.</p>
				</label>
			</div>
		</div>

		<!-- BYPASS MODIFIERS -->
		<div class="campaign-flag">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch input-id="bypass_modifiers" v-model="campaignStore.campaign.flags.bypass_modifiers.enabled" />
				</div>
				<label for="bypass_modifiers">
					<div class="title">Bypass Modifiers</div>
					<p>Bypass specified sorting bid modifiers for this campaign's bid.</p>
				</label>
			</div>
			<div v-if="campaignStore.campaign.flags.bypass_modifiers.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Modifers to Bypass:</label>
						<div class="controls">
							<div class="field">
								<p-chips add-on-blur v-model="campaignStore.campaign.flags.bypass_modifiers.modifiers" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- BYPASS PENDING LOGIC -->
		<div class="campaign-flag">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch
						input-id="bypass_pending_logic"
						v-model="campaignStore.campaign.flags.bypass_pending_logic.enabled"
					/>
				</div>
				<label for="bypass_pending_logic">
					<div class="title">Bypass Pending Status Logic</div>
					<p>Do not set the status of this campaign to "pending" if the balance is too low to purchase a lead.</p>
				</label>
			</div>
		</div>

		<!-- CANCELLATIONS -->
		<!-- <div class="campaign-flag">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch input-id="cancellations" v-model="campaignStore.campaign.cancellations.enabled" />
				</div>
				<label for="cancel_rate_threshold">
					<div class="title">Cancellations</div>
					<p>Enable cancel rate of leads purchased by this campaign.</p>
				</label>
			</div>
		</div> -->

		<!-- CANCEL LIMITS -->
		<div class="campaign-flag">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch
						input-id="cancel_limit"
						v-model="campaignStore.campaign.cancellations.successive_cancel_limit.enabled"
					/>
				</div>
				<label for="cancel_limit">
					<div class="title">Cancel Limits</div>
					<p>Set a limit to how many times a campaign can cancel successively.</p>
				</label>
			</div>
			<div v-if="campaignStore.campaign.cancellations.successive_cancel_limit.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Limit:</label>
						<div class="controls">
							<div class="field xs">
								<p-input-number v-model="campaignStore.campaign.cancellations.successive_cancel_limit.limit" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- CANCEL RATE THRESHOLD -->
		<div class="campaign-flag">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch
						input-id="cancel_rate_threshold"
						v-model="campaignStore.campaign.cancellations.custom_threshold.enabled"
					/>
				</div>
				<label for="cancel_rate_threshold">
					<div class="title">Custom Cancel Rate Threshold</div>
					<p>Set a threshold for the cancel rate of leads purchased by this campaign.</p>
				</label>
			</div>
			<div v-if="campaignStore.campaign.cancellations.custom_threshold.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Threshold:</label>
						<div class="controls">
							<div class="field xs">
								<p-input-percentage v-model="campaignStore.campaign.cancellations.custom_threshold.threshold" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- DEBUG -->
		<div class="campaign-flag">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch input-id="debug" v-model="campaignStore.campaign.flags.debug.enabled" />
				</div>
				<label for="debug">
					<div class="title">Debug Mode</div>
					<p>Check this campaign against all qualifiers in an auction even if one fails.</p>
				</label>
			</div>
		</div>

		<!-- DISABLE DUPLICATION -->
		<div class="campaign-flag">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch
						input-id="disable_duplication"
						v-model="campaignStore.campaign.flags.disable_duplication.enabled"
					/>
				</div>
				<label for="disable_duplication">
					<div class="title">Disable Duplication</div>
					<p>Do not allow this campaign to be duplicated.</p>
				</label>
			</div>
		</div>

		<!-- DISABLE LEG BUYOUTS (DEPRECATED) -->
		<div class="campaign-flag">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch
						input-id="disable_leg_buyouts"
						v-model="campaignStore.campaign.flags.disable_leg_buyouts.enabled"
					/>
				</div>
				<label for="disable_leg_buyouts">
					<div class="title">Disable Leg Buyouts</div>
					<p>Do not allow other shared campaigns to buyout the bid for this campaign.</p>
				</label>
			</div>
		</div>

		<!-- DISCOUNT BIDS -->
		<div class="campaign-flag">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch input-id="discount_bids" v-model="campaignStore.campaign.flags.discount_bids.enabled" />
				</div>
				<label for="discount_bids" v-if="campaignStore.campaign.product_targeting !== 'ad'">
					<div class="title">Discount Bids</div>
					<p>Discount the price of leads purchased by this campaign relative to the bid.</p>
				</label>
				<label for="discount_bids" v-else>
					<div class="title">Ad Network Fee</div>
					<p>
						Reduce the bid by the percentage that the ad network charges. 10% would reduce the bid to 90% of the
						original bid amount.
					</p>
				</label>
			</div>
			<div v-if="campaignStore.campaign.flags.discount_bids.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Multiplier:</label>
						<div class="controls">
							<div class="field xs">
								<p-input-percentage v-model="campaignStore.campaign.flags.discount_bids.multiplier" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- FREEZE FIELDS -->
		<div class="campaign-flag">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch input-id="frozen_fields" v-model="campaignStore.campaign.flags.frozen_fields.enabled" />
				</div>
				<label for="frozen_fields">
					<div class="title">Freeze Fields</div>
					<p>Freeze fields for this campaign so they cannot be edited. Fields available to freeze: name.</p>
				</label>
			</div>
			<div v-if="campaignStore.campaign.flags.frozen_fields.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Fields:</label>
						<div class="controls">
							<div class="field">
								<p-chips v-model="campaignStore.campaign.flags.frozen_fields.fields" separator="," />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- LOCK CAMPAIGN -->
		<div class="campaign-flag">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch input-id="lock_campaign" v-model="campaignStore.campaign.flags.lock.enabled" />
				</div>
				<label for="lock_campaign">
					<div class="title">Lock Campaign</div>
					<p>Lock this campaign so account users cannot edit it.</p>
				</label>
			</div>
		</div>

		<!-- NULLIFY PURCHASES -->
		<div class="campaign-flag">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch
						input-id="nullify_purchases"
						v-model="campaignStore.campaign.flags.nullify_purchases.enabled"
					/>
				</div>
				<label for="nullify_purchases">
					<div class="title">Nullify Purchases</div>
					<p>Set the purchase price to $0 for all purchases by this campaign.</p>
				</label>
			</div>
		</div>

		<!-- PRIORITIZE CAMPAIGN -->
		<div class="campaign-flag">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch
						input-id="prioritize_campaign"
						v-model="campaignStore.campaign.flags.prioritize_campaign.enabled"
					/>
				</div>
				<label for="prioritize_campaign">
					<div class="title">Prioritize Campaign</div>
					<p>Prioritize this campaign in auctions by buffing the sorting bid a set percentage of the time.</p>
				</label>
			</div>
			<div v-if="campaignStore.campaign.flags.prioritize_campaign.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Chance:</label>
						<div class="controls">
							<div class="field xs">
								<p-input-percentage v-model="campaignStore.campaign.flags.prioritize_campaign.percentage" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- REDUCE DOMINANCE -->
		<div class="campaign-flag">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch input-id="reduce_dominance" v-model="campaignStore.campaign.flags.reduce_dominance.enabled" />
				</div>
				<label for="reduce_dominance">
					<div class="title">Reduce Dominance</div>
					<p>Reduce the dominance of this campaign by nerfing the sorting bid for a percentage of auctions.</p>
				</label>
			</div>
			<div v-if="campaignStore.campaign.flags.reduce_dominance.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Chance:</label>
						<div class="controls">
							<div class="field xs">
								<p-input-percentage v-model="campaignStore.campaign.flags.reduce_dominance.percentage" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- SMART DELAY -->
		<div class="campaign-flag">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch input-id="smart_delay" v-model="campaignStore.campaign.flags.smart_delay.enabled" />
				</div>
				<label for="smart_delay">
					<div class="title">Smart Delay</div>
					<p>Set a custom delay (90s default) when shipping a lead purchased by this campaign.</p>
				</label>
			</div>
			<div v-if="campaignStore.campaign.flags.smart_delay.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Delay:</label>
						<div class="controls">
							<div class="field xs">
								<div class="p-inputgroup">
									<p-input-number v-model="campaignStore.campaign.flags.smart_delay.delay" class="input-align-right" />
									<div class="p-inputgroup-addon">s</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- BULK RETURNS -->
		<div class="campaign-flag" :class="{ disabled: !campaignStore.allow_bulk_returns }">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch
						:disabled="!campaignStore.allow_bulk_returns"
						input-id="bulk_returns"
						v-model="campaignStore.campaign.flags.bulk_returns.enabled"
					/>
				</div>
				<label for="bulk_returns" :class="{ disabled: !campaignStore.allow_bulk_returns }">
					<div class="title">Bulk Returns</div>
					<p class="disabled" v-if="!campaignStore.allow_bulk_returns">
						<strong>Currently this is disabled, it must first be enabled at the account setting level.</strong>
					</p>
					<p>Allow for purchases by this campaign to qualify in the Bulk Return that occurs at the end of the month</p>
				</label>
			</div>
		</div>

		<!-- SECONDARY PRICING DISABLED -->
		<div class="campaign-flag">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch input-id="disable_second_pricing" v-model="campaignStore.campaign.disable_second_pricing" />
				</div>
				<label for="disable_second_pricing">
					<div class="title">Second Pricing Disabled</div>
					<p>With this on, the purchase price will <strong>NOT</strong> be second priced.</p>
				</label>
			</div>
		</div>

		<!-- SORTING BID MULTIPLIER -->
		<div class="campaign-flag">
			<div class="select-row">
				<div class="toggle">
					<p-input-switch
						input-id="sorting_bid_multiplier"
						v-model="campaignStore.campaign.flags.sorting_bid_multiplier.enabled"
					/>
				</div>
				<label for="sorting_bid_multiplier">
					<div class="title">Sorting Bid Multiplier</div>
					<p>Multiply the sorting bid by a specified number to either buff or nerf the bid.</p>
				</label>
			</div>
			<div v-if="campaignStore.campaign.flags.sorting_bid_multiplier.enabled" class="settings-row">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Multiplier:</label>
						<div class="controls">
							<div class="field xs">
								<div class="p-inputgroup">
									<p-input-number
										mode="decimal"
										:max-fraction-digits="3"
										:min-fraction-digits="1"
										v-model="campaignStore.campaign.flags.sorting_bid_multiplier.amount"
									/>
									<div class="p-inputgroup-addon">x</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { useCampaignStore } from '@/stores/campaign';
import { mapStores } from 'pinia';
import InputCurrency from '@/components/forms/InputCurrency.vue';
import {compileAlgoBiddingVectors} from "@GQL";
import DatePicker from "@/components/forms/DatePicker.vue";

export default {
	name: 'CampaignFlagsContent',
	components: {DatePicker, InputCurrency },
	computed: {
		...mapStores(useCampaignStore),
	},
	data() {
		return {
			algo_mode_options: [
				{ value: 'live', label: 'Live Mode' },
				{ value: 'test', label: 'Test Mode' },
			],
      conversion_date: (new Date()).toISOString().slice(0,10),
      show_algo_vector_modal: false
		};
	},
  methods: {
    setAlgoBiddingDefaults() {
      this.campaignStore.setAlgoBiddingDefaults();
      this.$toast.add({
        severity: 'info',
        summary: 'Defaults have been set, make sure to update the target CPA and save the campaign',
        life: 8000
      });
    },
    async compileAlgoVectors() {
      if (this.campaignStore.campaign.id) {
        try {
          await compileAlgoBiddingVectors({
            campaign_id: this.campaignStore.campaign.id,
            conversion_date: this.conversion_date.toISOString()
          });
        }
        finally {
          this.$toast.add({
            severity: 'info',
            summary: 'Use the report in reporting.nextgenleads.app to query the vectors for this campaign',
            life: 10000
          });
          this.show_algo_vector_modal = false;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import (reference) '@/styles/responsive';

.disabled {
	color: var(--gray-50) !important;
}

.campaign-flag {
	background-color: white;
	border: 1px solid var(--gray-15);
	border-radius: 3px;
	margin-bottom: 1em;
	padding: 1em;

	&:last-of-type {
		margin-bottom: 0;
	}

	.title {
		font-weight: bold;
		margin: 0.25em 0;
	}

	label {
		font-weight: normal;

		p {
			line-height: 1.35em;
			margin-bottom: 0;
		}
	}

	.select-row {
		align-items: center;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
	}

	.toggle {
		margin-right: 1em;
	}

	.settings-row {
		border-top: 1px solid var(--gray-10);
		margin-top: 1em;
		padding-top: 1em;
	}
}

.justify-end {
	display: block;
	justify-self: end;
}
</style>
